// 🔹 Convierte la respuesta del endpoint en formato receptor
export function mapEntityToReceiver(entity) {
  if (!entity) return {}

  const data = entity.data || entity // ✅ soporte para Axios con .data
  if (!data) return {}

  const address = data.addresses?.[0] || {}
  const district = address.district?.name || ''
  const city = address.district?.city?.name || ''
  const activity = data.activities?.[0] || {}

  return {
    rut: data.tax_id?.replace(/\./g, '') || '',
    business_name: data.name || '',
    email: data.email || '',
    phone_number: address.phone || '',
    address: address.address || '',
    district,
    city,
    sii_branch_code: address.sii_branch_code || '',
    business_activity: activity.name || '',
    activity_code: activity.code || '',
    fromSii: true
  }
}
